import { StylesResultProps, useEditor } from "@grapesjs/react";
import { Accordion, Stack, Text } from "@mantine/core";

import { CustomStylePropertyField } from "./CustomStylePropertyField";

export const CustomStyleManager = ({
  sectors,
}: Omit<StylesResultProps, "Container">) => {
  const editor = useEditor();

  const selectedComponent = editor.getSelected();

  if (selectedComponent == null) {
    return null;
  }

  return (
    <Stack py={"sm"} spacing={0}>
      <Text size={"sm"} c={"dimmed"} ta={"center"} pt={"md"}>
        Styles
      </Text>
      <Accordion
        styles={{
          control: {
            padding: "16px 10px",
          },
          label: {
            fontWeight: 500,
          },
          content: {
            padding: "0",
          },
        }}
      >
        {sectors.map((sector) => {
          return (
            <Accordion.Item key={sector.getId()} value={sector.getId()}>
              <Accordion.Control>{sector.getName()}</Accordion.Control>
              <Accordion.Panel>
                <Stack p={12}>
                  {sector.getProperties().map((prop) => (
                    <CustomStylePropertyField key={prop.getId()} prop={prop} />
                  ))}
                </Stack>
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </Stack>
  );
};
